import { gql } from '@apollo/client';
import { DATA_ENTRY_FRAGMENT } from './queries';

export const BULK_EDIT_MUTATION = gql`
  ${DATA_ENTRY_FRAGMENT}
  mutation bulkEditDataEntries(
    $input: BulkEditDataEntriesInput!
    $clientId: ID!
    $startDate: RFC3339Date!
    $endDate: RFC3339Date!
  ) {
    bulkEditDataEntries(input: $input) {
      totalAffectedDataEntries
      dataEntries {
        ...DataEntryFragment
      }
    }
  }
`;

export const UNTAG_JOURNAL_ENTRY_CONTRACTORS = gql`
  mutation untag1099JournalEntryContractors($input: Untag1099Input!) {
    untag1099JournalEntryContractors(input: $input) {
      numberOfJournalEntriesUntagged
    }
  }
`;
